import React, { Component } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { withRouter } from "../utils/withRouter";
import Meals from "../models/meals-model";
import Cart from "../models/cart-model";
import SignalDispatcher from "../utils/signalDispatcher";
import userEventService from "../services/user-event.service";

interface GuestsPageProps {
    params: {
        service: string;
        id: string;
    };
}

interface GuestsState {
    service: string;
    id: string;
    title: string;
    description: string;
    image: string;
    price?: any;
    ticketCountAdult?: number;
    ticketCountJunior?: number;
    ticketCountChild?: number;
    ticketPriceAdult?: number;
    ticketPriceJunior?: number;
    ticketPriceChild?: number;
    adultPrice: number;
    juniorPrice: number;
    childPrice: number;
}

class Guests extends Component<GuestsPageProps, GuestsState> {
    constructor(props: GuestsPageProps) {
        super(props);
        this.state = { 
            service: this.props.params.service,
            id: this.props.params.id, 
            title: "City Tour", 
            description: "Explore the city with our guided tours.",
            image: "https://www.budapest-sightseeing.hu/wp-content/uploads/2021/06/dreamstime_xxl_144670741-1-scaled.jpg",
            ticketCountAdult: 0,
            ticketCountJunior: 0,
            ticketCountChild: 0,
            adultPrice: 5900,
            juniorPrice: 4900,
            childPrice: 2900
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'guests_page_open', {
            service: this.state.service,
            id: this.state.id
        });
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private incrementTickets(ticketType: string) {
        if (ticketType === 'adult') {
            this.setState({ ticketCountAdult: (this.state.ticketCountAdult ? this.state.ticketCountAdult : 0) + 1 });
        } else if (ticketType === 'junior') {
            this.setState({ ticketCountJunior: (this.state.ticketCountJunior ? this.state.ticketCountJunior : 0) + 1 });
        } else if (ticketType === 'child') {
            this.setState({ ticketCountChild: (this.state.ticketCountChild ? this.state.ticketCountChild : 0) + 1 });
        }
    }

    private decrementTickets(ticketType: string) {
        if (ticketType === 'adult') {
            this.setState({ ticketCountAdult: (this.state.ticketCountAdult && this.state.ticketCountAdult > 0) ? this.state.ticketCountAdult - 1 : 0 });
        } else if (ticketType === 'junior') {
            this.setState({ ticketCountJunior: (this.state.ticketCountJunior && this.state.ticketCountJunior > 0) ? this.state.ticketCountJunior - 1 : 0 });
        } else if (ticketType === 'child') {
            this.setState({ ticketCountChild: (this.state.ticketCountChild && this.state.ticketCountChild > 0) ? this.state.ticketCountChild - 1 : 0 });
        }
    }


    validateForCart() {
        return this.state.ticketCountAdult === 0 && this.state.ticketCountJunior === 0 && this.state.ticketCountChild === 0 ? true : false;
    }

    private addToCart() {
        let cartData = localStorage.getItem('cart');
        if (!cartData) {
            let initialCart: Cart;
            let ticketPriceAdult = this.state.ticketCountAdult && this.state.ticketCountAdult > 0 ? this.state.adultPrice * this.state.ticketCountAdult : 0;
            let ticketPriceJunior = this.state.ticketCountJunior && this.state.ticketCountJunior > 0 ? this.state.juniorPrice * this.state.ticketCountJunior : 0;
            let ticketPriceChild = this.state.ticketCountChild && this.state.ticketCountChild > 0 ? this.state.childPrice * this.state.ticketCountChild : 0;
            let totalPrice = ticketPriceAdult + ticketPriceJunior + ticketPriceChild;
            this.setState({ price: totalPrice });
            initialCart = {
                cartId: Math.floor(Math.random() * 1000000),
                events: [
                    {
                        id: this.state.id, 
                        name: this.state.service, 
                        date: new Date().toISOString().split('T')[0],
                        time: new Date().toISOString().split('T')[1].split('.')[0],
                        quantity: (this.state.ticketCountAdult ? this.state.ticketCountAdult : 0) + (this.state.ticketCountJunior ? this.state.ticketCountJunior : 0) + (this.state.ticketCountChild ? this.state.ticketCountChild : 0), 
                        price: this.state.price,
                        ages: {
                            adult: this.state.ticketCountAdult && this.state.ticketCountAdult > 0 ? this.state.ticketCountAdult : 0,
                            junior: this.state.ticketCountJunior && this.state.ticketCountJunior > 0 ? this.state.ticketCountJunior : 0,
                            child: this.state.ticketCountChild && this.state.ticketCountChild > 0 ? this.state.ticketCountChild : 0
                        },
                        agePrices: { 
                            adult: this.state.adultPrice, 
                            junior: this.state.juniorPrice, 
                            child: this.state.childPrice
                        }
                    }
                ],
                currency: 'HUF',
                totalPrice: totalPrice
            };
            localStorage.setItem('cart', JSON.stringify(initialCart));
            SignalDispatcher.emit('addToCart', initialCart);
        }
        else {
            let existingCart: Cart = JSON.parse(cartData);
            if (existingCart.events) {
                const eventIndex = existingCart.events.findIndex(event => event.id === this.state.id);
                if (eventIndex > -1) {
                    existingCart.events[eventIndex].quantity = (existingCart.events[eventIndex].quantity ? existingCart.events[eventIndex].quantity : 0) + (this.state.ticketCountAdult ? this.state.ticketCountAdult : 0) + (this.state.ticketCountJunior ? this.state.ticketCountJunior : 0) + (this.state.ticketCountChild ? this.state.ticketCountChild : 0);
                } else {
                    existingCart.events.push({
                        id: this.state.id, 
                        name: this.state.service, 
                        date: new Date().toISOString().split('T')[0],
                        time: new Date().toISOString().split('T')[1].split('.')[0],
                        quantity: (this.state.ticketCountAdult ? this.state.ticketCountAdult : 0) + (this.state.ticketCountJunior ? this.state.ticketCountJunior : 0) + (this.state.ticketCountChild ? this.state.ticketCountChild : 0), 
                        price: this.state.price,
                        ages: {
                            adult: this.state.ticketCountAdult && this.state.ticketCountAdult > 0 ? this.state.ticketCountAdult : 0,
                            junior: this.state.ticketCountJunior && this.state.ticketCountJunior > 0 ? this.state.ticketCountJunior : 0,
                            child: this.state.ticketCountChild && this.state.ticketCountChild > 0 ? this.state.ticketCountChild : 0
                        },
                        agePrices: { 
                            adult: this.state.adultPrice, 
                            junior: this.state.juniorPrice, 
                            child: this.state.childPrice
                        }
                    });
                }
            }
            else {
                existingCart.events = [
                    {
                        id: this.state.id, 
                        name: this.state.service, 
                        date: new Date().toISOString().split('T')[0],
                        time: new Date().toISOString().split('T')[1].split('.')[0],
                        quantity: (this.state.ticketCountAdult ? this.state.ticketCountAdult : 0) + (this.state.ticketCountJunior ? this.state.ticketCountJunior : 0) + (this.state.ticketCountChild ? this.state.ticketCountChild : 0), 
                        price: this.state.price,
                        ages: {
                            adult: this.state.ticketCountAdult && this.state.ticketCountAdult > 0 ? this.state.ticketCountAdult : 0,
                            junior: this.state.ticketCountJunior && this.state.ticketCountJunior > 0 ? this.state.ticketCountJunior : 0,
                            child: this.state.ticketCountChild && this.state.ticketCountChild > 0 ? this.state.ticketCountChild : 0
                        },
                        agePrices: { 
                            adult: this.state.adultPrice, 
                            junior: this.state.juniorPrice, 
                            child: this.state.childPrice
                        }
                    }
                ];
            }
            localStorage.setItem('cart', JSON.stringify(existingCart));
            SignalDispatcher.emit('addToCart', existingCart);
            this.navigatePage('/cart');
        }
    }

    render() {
        return (
            <Container className="oc-products">
                <Row key={1} className="oc-page-title">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h2>DETAILS OF YOUR RESERVATION</h2>
                    </Col>
                </Row>
                <Row key={2} className="oc-bordered">
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <strong className="oc-number-of-tickets-label">Number of tickets</strong>
                    </Col>
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <Row className="oc-number-of-tickets-row">
                            <Col lg={6} md={12} sm={12} xs={12}>
                                <strong className="oc-number-of-type-label">Adult</strong>
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <Button variant="light" className="oc-btn oc-btn-decrease" onClick={() => {this.decrementTickets('adult')}}>-</Button>
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <input type="text" className="oc-input oc-input-count" value={this.state.ticketCountAdult} readOnly />
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <Button variant="light" className="oc-btn oc-btn-increase" onClick={() => {this.incrementTickets('adult')}}>+</Button>
                            </Col>
                        </Row>
                        <Row className="oc-number-of-tickets-row">
                            <Col lg={6} md={12} sm={12} xs={12}>
                                <strong className="oc-number-of-type-label">Junior / Student</strong>
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <Button variant="light" className="oc-btn oc-btn-decrease" onClick={() => {this.decrementTickets('junior')}}>-</Button>
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <input type="text" className="oc-input oc-input-count" value={this.state.ticketCountJunior} readOnly />
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <Button variant="light" className="oc-btn oc-btn-increase" onClick={() => {this.incrementTickets('junior')}}>+</Button>
                            </Col>
                        </Row>
                        <Row className="oc-number-of-tickets-row">
                            <Col lg={6} md={12} sm={12} xs={12}>
                                <strong className="oc-number-of-type-label">Child (under 6 years)</strong>
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <Button variant="light" className="oc-btn oc-btn-decrease" onClick={() => {this.decrementTickets('child')}}>-</Button>
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <input type="text" className="oc-input oc-input-count" value={this.state.ticketCountChild} readOnly />
                            </Col>
                            <Col lg={1} md={2} sm={4} xs={4}>
                                <Button variant="light" className="oc-btn oc-btn-increase" onClick={() => {this.incrementTickets('child')}}>+</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row key={6}>
                    <Col lg={6} md={6} sm={6} xs={6} className="oc-text-left">
                        <Button className="oc-btn-default" onClick={() => this.navigatePage(`/products/${this.state.service}`)}>Back</Button>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6} className="oc-text-right">
                        <Button className="oc-btn-alert" disabled={this.validateForCart()} onClick={() => this.addToCart()}>Add to Cart</Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(Guests);